import React, { Component } from 'react';
import MultiposExamesPage from './multiplos-exames.page';
import { connect } from 'react-redux';
import WebapiCommon from '../../../../../../app/common/util/webapi.common';
import { bindActionCreators } from 'redux';
import * as actions from '../../material.action';
import * as commonActions from '../../../../../../app/common/common.action';
import { acessoPermitido } from '../../../../../../acessos.seguranca';

import IntlMessage from '../../../../../../helpers/intlMessage';

class MultiplosExamesContainer extends Component {
  constructor() {
    super();
    this.state = {
      modal: false,
      listagemExames: [],
      listagemMedicoSolicitante: [],
      exameSelecionado: undefined,
      quantidade: 1,
      medicoSelecionado: undefined,
      anotacao: undefined,
      modalAbertoEmEdicao: false,
      laudoExameSelecionado: undefined,
    };
  }

  componentDidMount() {
    var requests = [WebapiCommon.getExames()];

    if (this.props.listagemMedicoSolicitante.length === 0) {
      requests.push(WebapiCommon.getMedicos());
    } else {
      this.setState({
        listagemMedicoSolicitante: this.props.listagemMedicoSolicitante,
      });
    }
    Promise.all(requests).then((response) => {
      this.setState({
        listagemExames: response[0],
      });

      if (response.length > 1) {
        this.setState({
          listagemMedicoSolicitante: response[1],
        });
        this.props.commonActions.preencherMedicos(response[1]);
      }

      var medicoExecutante = this.state.listagemMedicoSolicitante.find(
        (medico) => medico.value === this.props.medicoExecutantePadrao
      );
      this.setState({
        medicoSelecionado: medicoExecutante,
      });
    });
  }

  render() {
    return (
      <MultiposExamesPage
        usuario={this.props.usuario}
        modal={this.state.modal}
        toggle={this.toggle.bind(this)}
        listagemExames={this.state.listagemExames}
        listagemMedicoSolicitante={this.state.listagemMedicoSolicitante}
        exameSelecionado={this.state.exameSelecionado}
        quantidade={this.state.quantidade}
        medicoSelecionado={this.state.medicoSelecionado}
        anotacao={this.state.anotacao}
        atualizaInputNoState={this.atualizaInputNoState.bind(this)}
        listagemMultiplosExames={this.props.listagemMultiplosExames}
        adicionarOuAtualizarExame={this.adicionarOuAtualizarExame.bind(this)}
        editarExame={this.editarExame.bind(this)}
        apagarExame={this.apagarExame.bind(this)}
        modalAbertoEmEdicao={this.state.modalAbertoEmEdicao}
        faturarExameComplementar={this.faturarExameComplementar.bind(this)}
        cancelamentoFaturamento={this.cancelamentoFaturamento.bind(this)}
        recebimentoFinalizado={this.props.recebimentoFinalizado}
        exameLiberado={this.props.exameFinalizado}
        acessoPermitido={acessoPermitido}
        altura={this.props.altura}
        exameFinalizado={this.props.exameFinalizado}
        faturarMedicoPadrao={this.props.faturarMedicoPadrao}
        disabledGravar={this.disabledGravar.bind(this)}
        medicoExecutantePadrao={this.props.medicoExecutantePadrao}
      />
    );
  }

  toggle() {
    if (this.state.modal) {
      this.setState({
        modal: !this.state.modal,
        modalAbertoEmEdicao: false,
        laudoExameSelecionado: undefined,
      });
    } else {
      this.setState({
        modal: !this.state.modal,
      });
    }
  }

  disabledGravar() {
    return (
      !this.state.medicoSelecionado ||
      !this.state.exameSelecionado ||
      !this.state.quantidade
    );
  }

  cancelamentoFaturamento(exameId) {
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.cancelamentoFaturamento(exameId).then(() => {
      WebapiCommon.getListagemMultiplosExames(
        this.props.laudoSelecionado.laudo
      ).then((listagem) => {
        this.props.actions.atualizarListagemMultiplosExames(listagem);
        this.props.commonActions.showFadeCarregando(false);
      });
    });
  }

  atualizaInputNoState(name, value) {
    this.setState({
      [name]: value,
    });
  }

  faturarExameComplementar(exameId) {
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.faturarExameComplementar(exameId).then(() => {
      WebapiCommon.getListagemMultiplosExames(
        this.props.laudoSelecionado.laudo
      ).then((listagem) => {
        this.props.actions.atualizarListagemMultiplosExames(listagem);
        this.props.commonActions.showFadeCarregando(false);
      });
    });
  }

  apagarExame(exameId) {
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.apagarRegistroExameMultiplosExames(exameId).then((json) => {
      WebapiCommon.getListagemMultiplosExames(
        this.props.laudoSelecionado.laudo
      ).then((listagem) => {
        this.props.actions.atualizarListagemMultiplosExames(listagem);
        this.props.commonActions.showFadeCarregando(false);

        if (json.data.sucesso) {
          this.props.commonActions.showAlerta(
            'sucesso',
            <IntlMessage id = "dashboards.examDetail.complementaryExamRemoved"/>,
            1500
          );
        } else {
          this.props.commonActions.showAlerta('erro', json.data.mensagem, 1500);
        }
      });
    });
  }

  editarExame(exameId) {
    this.props.commonActions.showFadeCarregando(true);
    WebapiCommon.obterMultiExames(exameId).then((exame) => {
      this.setState({
        exameSelecionado: {
          label: exame.exame,
          value: exame.exameId,
        },
        medicoSelecionado: {
          label: exame.medicoExecutante,
          value: exame.medicoExecutanteId,
        },
        quantidade: exame.qtdFat,
        anotacao: exame.anotacoes,
        modalAbertoEmEdicao: true,
        laudoExameSelecionado: exameId,
      });
      this.props.commonActions.showFadeCarregando(false);
      this.toggle();
    });
  }

  adicionarOuAtualizarExame() {
    this.props.commonActions.showFadeCarregando(true);

    if (this.state.modalAbertoEmEdicao) {
      this.atualizarMultiploExame();
    } else {
      this.registrarMultiploExame();
    }
  }

  registrarMultiploExame() {
    const registrarMultiplosExamesRequest = {
      exameId: this.state.exameSelecionado.value,
      medicoId: this.state.medicoSelecionado.value,
      qtdFat: this.state.quantidade,
      anotacoes: this.state.anotacao,
    };
    WebapiCommon.registrarMultiplosExames(
      this.props.laudoSelecionado.laudo,
      registrarMultiplosExamesRequest
    ).then(() => {
      WebapiCommon.getListagemMultiplosExames(
        this.props.laudoSelecionado.laudo
      ).then((listagem) => {
        this.props.actions.atualizarListagemMultiplosExames(listagem);
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta(
          'sucesso',
          <IntlMessage id = "dashboards.examDetail.additionalExamAdded"/>,
          1500
        );
        this.toggle();

        this.setState({
          anotacao: '',
          exameSelecionado: undefined,
          quantidade: 1,
        });

        if (
          !this.props.faturarMedicoPadrao ||
          !this.props.medicoExecutantePadrao
        ) {
          this.setState({
            medicoSelecionado: undefined,
          });
        }
      });
    });
  }

  atualizarMultiploExame() {
    const atualizarMultiplosExamesRequest = {
      medicoExecutanteId: this.state.medicoSelecionado.value,
      qtdFat: this.state.quantidade,
      anotacoes: this.state.anotacao,
    };
    WebapiCommon.atualizarExameMultiplosExames(
      this.state.laudoExameSelecionado,
      atualizarMultiplosExamesRequest
    )
      .then(() => {
        WebapiCommon.getListagemMultiplosExames(
          this.props.laudoSelecionado.laudo
        ).then((listagem) => {
          this.props.actions.atualizarListagemMultiplosExames(listagem);
          this.props.commonActions.showFadeCarregando(false);
          this.props.commonActions.showAlerta(
            'sucesso',
            <IntlMessage id = "dashboards.examDetail.updatedSupplementaryExam"/>,
            1500
          );
          this.toggle();
        });
      })
      .catch((err) => {
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta(
          'erro',
          <IntlMessage id = "dashboards.examDetail.failedEditExam"/>,
          1500
        );
      });
  }
}

const mapStateToProps = (state) => {
  return {
    usuario: state.usuario,
    listagemMultiplosExames: state.recebimentoMaterial.listagemMultiplosExames,
    detalhes: state.commonReducer.detalhes,
    laudoSelecionado: state.commonReducer.laudoSelecionado,
    recebimentoFinalizado: state.recebimentoMaterial.recebimentoFinalizado,
    listagemMedicoSolicitante: state.commonReducer.medicos,
    exameFinalizado: state.commonReducer.exameFinalizado,
    faturarMedicoPadrao: state.recebimentoMaterial.faturarMedicoPadrao,
    medicoExecutantePadrao: state.recebimentoMaterial.medicoExecutantePadrao,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultiplosExamesContainer);



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/multiplosExames/multiplos-exames.container.js